<ng-container>
    <div class="overlay-warp number-filter-wrap">
        <input
            type="number"
            class="number-input"
            [formControl]="valueControl"
            placeholder="{{'grid.reports.questionnaireNumberPlaceholder' | translate}}"
            (keydown.enter)="apply()"
            (blur)="apply()"
        />
    </div>
</ng-container>
